/* eslint-disable */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-return-assign */
/* eslint eqeqeq: "off", curly: "error" */
/* eslint no-const-assign: "off", curly: "error" */
/* eslint assignment: "off", curly: "error" */
/* eslint assign: "off", curly: "error" */
import { useState, useEffect, useRef, useContext } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { DateTime } from 'luxon';
import LeadForm from '../../components/LeadForm';
import { Header, LogoDiv, Container, Leads, LeadsContainer, ButtonBox, StatesWrapper } from './styles';
import { MainContext } from '../../context/ApiContext';
import LeadList from '../../components/Dashboard/LeadList';
import MenuButton from '../../components/Dashboard/MenuButton';
import MenuItem from '../../components/Dashboard/MenuItem';
import LeadCard from '../../components/Dashboard/LeadCard';
import Navbar from '../../components/Dashboard/Navbar';
import Logo from '../../components/Logo';
import FullScreenDialog from '../../components/FullScreenDialog';
import { Backdrop, Badge, Fade, makeStyles, Modal } from '@material-ui/core';
import MenuItemAgendamentos from '../../components/Dashboard/MenuItemAgendamentos';
import LoadingPage from '../LoadingPage';
import { toast } from 'react-toastify';
import { listToMatrix } from '../../utils/array';
import { FixedSizeGrid as Grid } from 'react-window';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import LeadsGridVirtualized from '../../components/LeadsGridVirtualized';
import useSWR from 'swr';
import { fetcher, variantFetcher } from '../../service/SWRFetcher';
import LeadView from '../../components/LeadView';
import { removeMask } from '../../utils/masks';
import { canCaptureLead } from '../../utils/lead';
import { Button, Box } from '@material-ui/core';
import { useAuth } from '../../hooks/useAuth';
import useApp from '../../hooks/useApp';
import { FullPageLoading } from '../../components/FullPageLoading';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: '60%',
    height: '80%',
    borderRadius: 8,
    minWidth: '500px',
    minHeight: '300px',
    padding: '24px 32px',
    boxShadow: theme.shadows[5],
    backgroundColor: theme.palette.background.paper,
  },
}));

const Lead = () => {
  const { user } = useAuth();
  const { refresh_lead_seconds, lead_status, insurances, fi_indication_stock, setState } = useApp();
  const {
    // values,
    // getters,
    // auth: { getUserInfo },
  } = useContext(MainContext);
  const { height, width } = useWindowDimensions();
  const [open, setOpen] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [openLeadView, setOpenLeadView] = useState(false);
  const [showOnly, setShowOnly] = useState(false);
  const [lead, setLead] = useState();
  const [leadCount, setLeadCount] = useState();
  const [lockTabs, setLockTabs] = useState(false);
  const [convertedLeads, setConvertedLeads] = useState(null);
  const [schedulesLead, setSchedulesLead] = useState({ count: null, expired: false });
  const [leadToEdit, setLeadToEdit] = useState(null);
  const [isSchedulable, setIsSchedulable] = useState(false);
  const [leadsListCount, setLeadsListCount] = useState(false);
  const [leadsList, setLeadsList] = useState(false);
  const [filter, setFilter] = useState({
    lead_id: '',
    status: 1,
    state: 1,
    name: 'Origem',
    client_phone: '',
    channel: 1,
    insurance: 1,
    partner: null,
    schedule: false,
    sevenDays: false,
    onlySchedules: false,
    start_date: '',
    end_date: '',
    clientName: '',
    broker: '',
    cpf: '',
    isStatusFilterButton: 0,
  });
  const { data: leadsCount, mutate: mutateCount } = useSWR(`/leads/list-count`, fetcher, {
    refreshInterval: (refresh_lead_seconds || 1) * 1000 ?? 600000,
  });
  const {
    data: leads,
    mutate: mutateList,
    isValidating,
    error,
  } = useSWR(
    `/leads/list-broker?` +
      `channel_id=${filter.channel || ''}` +
      `&client_name=${filter.clientName || ''}` +
      `&client_cpf=${removeMask(filter.cpf) || ''}` +
      `&broker=${filter.broker || ''}` +
      `&status=${filter.status || ''}` +
      `&schedule=${filter.schedule ? 1 : ''}` +
      `&saven_days=${filter.sevenDays ? 1 : ''}` +
      `&only_schedules=${filter.onlySchedules ? 1 : ''}` +
      `&status=${filter.status || ''}` +
      `&state=${filter.state || ''}` +
      `&start_date=${filter.start_date || ''}` +
      `&end_date=${filter.end_date || ''}` +
      `&partner_id=${filter.partner || ''}` +
      `&lead_id=${filter.lead_id || ''}` +
      `&isStatusFilterButton=${filter.isStatusFilterButton || ''}` +
      `&insurance_id=${filter.insurance || ''}` +
      `&client_phone=${filter.client_phone || ''}`,
    fetcher,
    { refreshInterval: (refresh_lead_seconds || 1) * 1000 ?? 600000 }
  );

  const { data: older, mutate: mutateOlder } = useSWR(`/leads/older?channel_id=${filter.channel || ''}`, fetcher, {});
  // const {
  //   values: { insurances },
  // } = useContext(MainContext);
  const [selectedAttendanceFlow, setSelectedAttendanceFlow] = useState([1, 2, 3, 4, 5, 6, 7]);
  const isInitialFlowMount = useRef(true);

  const ATTENDANCE_FLOW_VERSION = 3;

  useEffect(() => {
    const storedVersion = Number(localStorage.getItem('pessego_attendance_flow_version'));
    const attendantFlow = JSON.parse(localStorage.getItem('pessego_attendance_flow'));
    if (attendantFlow && storedVersion === ATTENDANCE_FLOW_VERSION) {
      setSelectedAttendanceFlow(attendantFlow);
    } else {
      setSelectedAttendanceFlow([1, 8, 9, 10, 2, 3, 4, 5, 6, 7]);
      localStorage.setItem('pessego_attendance_flow', JSON.stringify([1, 8, 9, 10, 2, 3, 4, 5, 6, 7]));
      localStorage.setItem('pessego_attendance_flow_version', ATTENDANCE_FLOW_VERSION);
    }
  }, []);

  useEffect(() => {
    if (isInitialFlowMount.current) {
      isInitialFlowMount.current = false;
      return;
    }
    localStorage.setItem('pessego_attendance_flow', JSON.stringify(selectedAttendanceFlow));
    localStorage.setItem('pessego_attendance_flow_version', ATTENDANCE_FLOW_VERSION);
  }, [selectedAttendanceFlow]);

  useEffect(() => {
    if (leadsCount) {
      setLeadsListCount(leadsCount?.count);
    }
  }, [leadsCount]);

  useEffect(() => {
    if (leads) {
      setLeadsList(leads);
    }
  }, [leads]);

  // useEffect(() => {
  //   setState('loading', (isValidating && !error));
  // }, [isValidating]);

  const leadsFilteredCount = () => {
    lead_status?.forEach((status) => {
      setLeadCount((state) => ({ ...state, [status.var_id]: countFilteredStatus(status.var_id) }));
    });
  };

  const handleEditLead = (ld) => {
    mutateList();
    mutateCount();
    setLeadToEdit(ld);
    setOpen(true);
  };
  const handleViewLead = (ld) => {
    setLead(ld);
    setOpenLeadView(true);
  };

  const handleViewLeadShowOnly = (ld) => {
    setLead(ld);
    setOpenLeadView(true);
    setShowOnly(true);
  };

  function countStatus(sts) {
    const count = leadsListCount?.leads_status_count?.find((count) => count.status == sts);
    if (sts == 6) return count?.news ?? 0;
    return count?.total ?? 0;
  }

  function countFilteredStatus(sts) {
    let count = 0;
    leadsList?.leads.forEach((lead) => {
      if (lead.status == sts) count++;
    });
    return count;
  }

  const nextSchedulers = () => {
    // const now = DateTime.now();
    // const aWeek = now.plus({ days: 7 });
    // // const nextLeads = values.leads.filter((l) => {
    // const nextLeads = values.leads.filter((l) => {
    //   if (!l.lead_scheduling || l.lead_scheduling.status === 1) return false;
    //   if (l.status == 1 && (l.channel_id == 6 || l.channel_id == 10)) {
    //     if (l.broker_id != user?.id) return false;
    //   }
    //   const schedule_date = new Date(l.lead_scheduling?.scheduling_date);
    //   if (schedule_date <= aWeek) {
    //     return true;
    //   }
    // });
    // let expired = false;
    // let expiredNum = 0;
    // nextLeads.map((nl) => {
    //   const schedule_date = new Date(nl.lead_scheduling?.scheduling_date);
    //   if (schedule_date < now) {
    //     expired = true;
    //     expiredNum++;
    //   }
    // });
    let expired = false;
    const expiredNum = leadsListCount?.leads_status_count?.reduce(
      (acc, cur) => (acc += Number(cur.late_scheduling)),
      0
    );
    if (expiredNum > 0) expired = true;
    setSchedulesLead({ count: expiredNum, expired });
  };

  useEffect(() => {
    nextSchedulers();
    setLockTabs(true);
  }, [leadsList]);

  const OlderCalc = (ls) => {
    let older = true;
    leadsList?.leads.map((l) => {
      if (l.channel_id != ls.channel_id) return false;
      if (l.state != ls.state) return false;
      if (l.insurance_id != ls.insurance_id) return false;
      if (l.create_lead_date < ls.create_lead_date) {
        older = false;
      }
    });

    return older;
  };

  //#region Transforma o array de Leads filtrado em um array bidimencional e cria um Cell para a virtualizaçao da lead
  useEffect(() => {
    if (leadsList?.leads) {
      const orderedLeads = [...leadsList.leads].sort((a, b) => {
        const aCapture = canCaptureLead(a, user, older) ? 0 : 1;
        const bCapture = canCaptureLead(b, user, older) ? 0 : 1;
        if (aCapture !== bCapture) return aCapture - bCapture;
        return a.status < b.status ? -1 : 1;
      });
      const matrix = listToMatrix(orderedLeads, width > 1366 ? 4 : 3);
      setConvertedLeads(matrix);

      if (lockTabs == false) {
        leadsFilteredCount();
      }
    }
  }, [leadsList, filter, older]);

  const Cell = ({ columnIndex, rowIndex, style }) => (
    <div
      className={
        columnIndex % 2
          ? rowIndex % 2 === 0
            ? 'GridItemOdd'
            : 'GridItemEven'
          : rowIndex % 2
          ? 'GridItemOdd'
          : 'GridItemEven'
      }
      style={style}>
      {convertedLeads && rowIndex < convertedLeads.length && columnIndex < convertedLeads[rowIndex].length && (
        <LeadCard
          older={older}
          lead={convertedLeads[rowIndex][columnIndex]}
          key={convertedLeads[rowIndex][columnIndex].id}
          onClick={handleEditLead}
          onClickView={handleViewLead}
          onClickShowOnly={handleViewLeadShowOnly}
          user={user}
          mutate={() => {
            mutateCount();
            mutateList();
          }}
        />
      )}
    </div>
  );
  //#endregion

  const classes = useStyles();

  const isStockFunnel = [8, 9, 10].includes(filter.status);

  const menuItems = [
    <MenuButton
      status={filter.status}
      index={1}
      count={countStatus(1)}
      subCount={leadsListCount?.leads_channel_count}
      className="blue first-button"
      name="Origem"
      user={user}
      onChangeFlow={(flow) => setSelectedAttendanceFlow(flow)}
      onClick={(e, i) => {
        setFilter({
          ...filter,
          state: 1,
          status: 1,
          channel: e,
          schedule: false,
          insurance: i,
          partner: null,
          name: 'Origem',
        });
        setIsSchedulable([6, 7, 8, 9, 10].includes(e));
      }}
    />,
    <MenuItem
      status={filter.status}
      index={2}
      count={countStatus(2)}
      className="yellow"
      name="Negociação"
      onClick={() => {
        setFilter({
          ...filter,
          state: 2,
          status: 2,
          channel: null,
          schedule: false,
          insurance: null,
          partner: null,
          name: 'Negociação',
        });
        setIsSchedulable(false);
      }}
    />,
    <MenuItem
      status={filter.status}
      index={3}
      count={countStatus(3)}
      className="sea"
      name="Whatsapp/Ligou"
      onClick={() => {
        setFilter({
          ...filter,
          state: 2,
          status: 3,
          channel: null,
          schedule: false,
          insurance: null,
          partner: null,
          name: 'Whatsapp/Ligou',
        });
        setIsSchedulable(false);
      }}
    />,
    <MenuItem
      status={filter.status}
      index={4}
      count={countStatus(4)}
      className="purple"
      name="Envio Cotação"
      onClick={() => {
        setFilter({
          ...filter,
          state: 2,
          status: 4,
          channel: null,
          schedule: false,
          insurance: null,
          partner: null,
          name: 'Envio Cotação',
        });
        setIsSchedulable(false);
      }}
    />,
    <MenuItem
      status={filter.status}
      index={5}
      count={countStatus(5)}
      className="gray"
      name="Vendido c/ Pendência"
      onClick={() => {
        setFilter({
          ...filter,
          state: 2,
          status: 5,
          channel: null,
          schedule: false,
          insurance: null,
          name: 'Vendido c/ Pendência',
        });
        setIsSchedulable(false);
      }}
    />,
    <MenuItem
      status={filter.status}
      index={6}
      count={countStatus(6)}
      className="green"
      name="Finalizados"
      onClick={() => {
        setFilter({
          ...filter,
          state: 3,
          status: 6,
          channel: null,
          schedule: false,
          insurance: null,
          partner: null,
          name: 'Finalizados',
        });
        setIsSchedulable(false);
      }}
    />,
    <MenuItemAgendamentos
      nextSch={schedulesLead}
      count={leadsCount?.agendaments_count}
      className="orange last-button"
      name="Agendamentos"
      onClick={() => {
        setFilter({
          ...filter,
          state: null,
          status: null,
          channel: null,
          schedule: true,
          insurance: null,
          partner: null,
          sevenDays: true,
          name: 'Agendamentos',
        });
        setIsSchedulable(true);
      }}
    />,
    <MenuItem
      status={filter.status}
      index={8}
      count={countStatus(8)}
      className="indigo"
      name="Atendimento IA"
      onClick={() => {
        setFilter({
          ...filter,
          state: 1,
          status: 8,
          channel: 1,
          schedule: false,
          insurance: null,
          partner: null,
          name: 'Atendimento IA',
        });
        setIsSchedulable(false);
      }}
    />,
    <MenuItem
      status={filter.status}
      index={9}
      count={countStatus(9)}
      className="cyan"
      name="Esquentado IA"
      onClick={() => {
        setFilter({
          ...filter,
          state: 1,
          status: 9,
          channel: 1,
          schedule: false,
          insurance: null,
          partner: null,
          name: 'Esquentado IA',
        });
        setIsSchedulable(false);
      }}
    />,
    <MenuItem
      status={filter.status}
      index={10}
      count={countStatus(10)}
      className="red"
      name="Desinteressado IA"
      onClick={() => {
        setFilter({
          ...filter,
          state: 1,
          status: 10,
          channel: 1,
          schedule: false,
          insurance: null,
          partner: null,
          name: 'Desinteressado IA',
        });
        setIsSchedulable(false);
      }}
    />,
  ];

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <FullScreenDialog open={open} setOpen={setOpen}>
        <LeadForm
          type="edit"
          leadCurrent={leadToEdit}
          setOpen={setOpen}
          mutate={() => {
            mutateList();
            mutateCount();
          }}
        />
      </FullScreenDialog>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openLeadView}
        onClose={() => setOpenLeadView(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}>
        <Fade in={openLeadView}>
          <div className={classes.paper}>
            <LeadView lead={lead} showOnly={showOnly} />
          </div>
        </Fade>
      </Modal>
      {leadsList && leadsListCount && (
        <>
          <Header>
            <div className="container">
              <div className="content">
                <LogoDiv>
                  <Link to="/">
                    <Logo />
                  </Link>
                </LogoDiv>
                <StatesWrapper>
                  {selectedAttendanceFlow.map((item) => {
                    return menuItems[item - 1];
                  })}
                </StatesWrapper>
              </div>
            </div>
          </Header>
          <Container>
            {/* <button type="button" onClick={nextSchedulers}>
          Teste
        </button> */}
            <Navbar
              clickSevenDays={() => setFilter({ ...filter, sevenDays: !filter.sevenDays })}
              clickOnlySchedules={() => setFilter({ ...filter, onlySchedules: !filter.onlySchedules })}
              checkValue={filter.sevenDays}
              checkValueSchedules={filter.onlySchedules}
              clickFilter={(name, cpf, broker, start_date, end_date, lead_id, client_phone) => {
                if (name || cpf || broker || start_date || end_date || lead_id || client_phone) {
                  console.log('lead_id', lead_id, client_phone);
                  setFilter({
                    ...filter,
                    lead_id,
                    clientName: name,
                    client_phone,
                    broker,
                    cpf,
                    start_date,
                    end_date,
                    state: null,
                    status: null,
                    channel: null,
                    partner: null,
                    insurance: null,
                    schedule: false,
                    name: 'Resultados',
                    sevenDays: false,
                    onlySchedules: false,
                  });
                  leadsFilteredCount();
                }
              }}
              clearFilter={() =>
                setFilter({
                  status: 1,
                  state: 1,
                  name: 'Origem',
                  channel: 1,
                  insurance: 1,
                  partner: null,
                  schedule: false,
                  sevenDays: false,
                  onlySchedules: false,
                  start_date: '',
                  end_date: '',
                  clientName: '',
                  broker: '',
                  cpf: '',
                  isStatusFilterButton: 0,
                })
              }
              clickFilterBtn={(name, value) => {
                if (value === 0) setFilter({ ...filter, partner: null, insurance: null, channel: null, [name]: null });
                else setFilter({ ...filter, partner: null, insurance: null, channel: null, [name]: value });
              }}
              clearSelected={() => setIsSelected(false)}
              scheduler={isSchedulable}
              showStock={isStockFunnel}
              stockValue={filter.insurance}
              changeStock={(id) => setFilter({ ...filter, insurance: id })}
              setLockTabs={setLockTabs}
            />

            <div className="leadBar">
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box>
                  {filter.name}{' '}
                  {filter.channel && `- ${user?.technical_team?.channels?.find((c) => c.id === filter.channel)?.name}`}{' '}
                  {filter.insurance &&
                    (isStockFunnel
                      ? `- ${fi_indication_stock?.find((s) => s.var_id === filter.insurance)?.value ?? ''}`
                      : `- ${insurances?.find((c) => c.id === filter.insurance)?.name}`)}
                </Box>
                <Box>
                  {filter.name === 'Resultados' && filter.onlySchedules != true && (
                    <ButtonBox>
                      <Box sx={{ display: 'flex' }}>
                        {lead_status?.map((status) => (
                          <>
                            {status.var_id != 7 && (
                              <Button
                                key={status.id}
                                className="button"
                                type="button"
                                fullWidth
                                onClick={() => {
                                  setFilter({ ...filter, status: status.var_id, isStatusFilterButton: 1 }),
                                    setIsSelected(status.var_id);
                                }}
                                style={{
                                  marginTop: '8px',

                                  background: isSelected == status.var_id ? '#f26522' : '',
                                  color: isSelected == status.var_id ? '#ffffff' : '',
                                }}
                                variant="contained">
                                {status.value}
                                <br />

                                {leadCount?.[status.var_id]}
                              </Button>
                            )}
                          </>
                        ))}
                      </Box>
                    </ButtonBox>
                  )}
                </Box>
              </Box>
            </div>
            <LeadsGridVirtualized rows={convertedLeads?.length}>{Cell}</LeadsGridVirtualized>
          </Container>
        </>
      )}
    </motion.div>
  );
};
export default Lead;
